import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UzurvDirectivesModule } from '@uzurv/core';
import { clearState } from '../../app/store/clear-state.reducer';
import { RequiresPermissionsModule } from '../../components/directives';
import { ReservationDetailModule } from '../../components/reservation';
import { RiderCardModule } from '../../components/rider-card/rider-card.module';
import { TripChatDetailModule } from '../../components/trip-chat-detail/trip-chat-detail.module';
import { TripDriverDetailModule } from '../../components/trip-driver-detail/trip-driver-detail.module';
import { TripFareAdjustmentDetailModule } from '../../components/trip-fare-adjustment-detail/trip-fare-adjustment-detail.module';
import { TripIdDetailModule } from '../../components/trip-id-detail/trip-id-detail.module';
import { TripItineraryDetailModule } from '../../components/trip-itinerary-detail/trip-itinerary-detail.module';
import { TripMapOverlayModule } from '../../components/trip-map-overlay/trip-map-overlay.module';
import { TripNotesDetailModule } from '../../components/trip-notes-detail/trip-notes-detail.module';
import { TripOverviewDetailModule } from '../../components/trip-overview-detail/trip-overview-detail.module';
import { TripRiderDetailModule } from '../../components/trip-rider-detail/trip-rider-detail.module';
import { TripDetailEffects } from '../../store/trip-detail/trip-detail.effects';
import { reducer } from '../../store/trip-detail/trip-detail.reducer';
import { TripDetailPageComponent } from './trip-detail.page';


@NgModule({
  declarations: [TripDetailPageComponent],
  imports: [
    CommonModule,
    StoreModule.forFeature('tripDetail', reducer, { metaReducers: [clearState] }),
    EffectsModule.forFeature([TripDetailEffects]),
    MatCardModule,
    MatToolbarModule,
    MatIconModule,
    MatTabsModule,
    MatInputModule,
    MatButtonModule,
    MatDividerModule,
    UzurvDirectivesModule,
    RequiresPermissionsModule,
    ReservationDetailModule,
    TripRiderDetailModule,
    TripDriverDetailModule,
    TripIdDetailModule,
    TripOverviewDetailModule,
    TripMapOverlayModule,
    TripChatDetailModule,
    TripNotesDetailModule,
    TripFareAdjustmentDetailModule,
    TripItineraryDetailModule,
    RiderCardModule
  ],
  exports: [TripDetailPageComponent]
})
export class TripDetailModule {}
